import Basic from '@/components/page/Basic.js'
import { /*Rainbow, Rainbow2,*/ AxiosWithJar,Config } from '@/utility.js'

export default{
	extends: Basic,
	props:["branchid"],
	data:()=>({
        unit: {atgonline:[], spbuupdate:[], atgoffline:[], spbunotupdate:[], storeupdate:[], storenotupdate:[], list:[] }, 
        spbu:{ data:{}, list:[], types:[] },
        store:{ data:{}, list:[], types:[] },
		loading: { atgchart:true, updatechart:true, table:true, overview:true },
	}),
	methods:{
	
        //used
		async loadRecapMonitor() {
			let url = Config().apiURL + "/maintenance/recapmonitor"
			await AxiosWithJar().get(url).then(result => {
				//if (result.data.atgonline.length) {
					this.unit.atgonline = result.data.atgonline;
					this.unit.atgoffline = result.data.atgoffline;
					this.unit.spbuupdate = result.data.spbuupdate;
					this.unit.spbunotupdate = result.data.spbunotupdate;
					this.unit.storeupdate = result.data.storeupdate;
					this.unit.storenotupdate = result.data.storenotupdate;
					
				//}
			})
			.catch(/*error => {
				//console.log(error)
			}*/)
			.finally(() => {
				this.loading.overview = false;
				this.loading.atgchart = false;
				this.loading.updatechart = false;
			})
		},

        //used
        async loadStationList(type='') {
			let url = Config().apiURL + "/fuel2/station?"  + (type ? "&type=" + type : "") + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.spbu.list = result.data.data;
				}
			})
		},

		//All branch
		async loadStoreList3() {
			let url = Config().apiURL + "/bright/storelist3";
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.store.list = result.data.data;
					//console.log('this.store.list: ' + JSON.stringify(this.store.list))
				}
			})
		},

	},
}